<script setup lang="ts">
import { faIconStyle } from '~/utils/faIconStyle'
import type { AdmissionStep } from '~/composables/useAdmissions'

defineProps<{
  steps: AdmissionStep[]
  nextSession: string
}>()
</script>

<template>
  <div>
    <!-- Admission Steps -->
    <section class="py-20 bg-background relative overflow-hidden">
      <div class="container mx-auto px-6">
        <UiSectionHeader 
          align="left"
          titlePrefix="Le Processus"
          titleHighlight="d'Admission"
          subtitle="L'admission à OXO se fait sur dossier et entretien. Nous recherchons des talents passionnés, curieux et prêts à s'investir dans une formation intense."
        />

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-12">
          <div v-for="step in steps" :key="step.id" 
            class="p-10 rounded-3xl bg-oxo-card-bg/20 border border-oxo-border flex flex-col items-center text-center"
          >
            <div class="w-20 h-20 rounded-2xl bg-linear-to-br from-oxo-red to-oxo-yellow flex items-center justify-center text-white text-4xl mb-8 shadow-lg shadow-oxo-red/20">
              <i :style="faIconStyle('fas fa-' + step.icon.replace('fa-', ''))" :class="'fas fa-' + step.icon.replace('fa-', '')" aria-hidden="true"></i>
            </div>
            <div class="text-oxo-red font-black text-xs uppercase tracking-widest mb-3">Étape 0{{ step.id }}</div>
            <h3 class="font-display font-bold text-xl text-foreground mb-4">{{ step.title }}</h3>
            <p class="text-foreground-dim text-sm leading-relaxed">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
